import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { CtaMessage } from '@marvelapp/ballpark-components';
import { CheckRadioIcon } from '@marvelapp/ballpark-icons';
export const SessionEnded = observer(function SessionEnded() {
    return (_jsx(CtaMessage.Root, { children: _jsxs(CtaMessage.Header, { icon: _jsx(CheckRadioIcon, {}), children: [_jsx(CtaMessage.Heading, { children: "Session has ended" }), _jsx(CtaMessage.Description, { children: "This Ballpark live session is now over, so you can close this tab." })] }) }));
});
